module.exports = __webpack_public_path__ + "img/VIDEO.2879992a.png";